// Livrare estimată pe pagina de produs: Comanzi azi -> trimitem mâine -> primești coletul.
// Calculul se face în browser, după ora Moldovei, ca datele să fie corecte chiar dacă
// pagina vine din cache. Regula (1 / 3-5 zile) vine din atributele data-* ale blocului.
(() => {
  'use strict';
  if (customElements.get('pf-livrare')) return;

  const ZI = 864e5;
  const LUNI = ['ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie',
    'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie'];
  const LUNI_SCURT = ['ian.', 'feb.', 'mar.', 'apr.', 'mai', 'iun.',
    'iul.', 'aug.', 'sept.', 'oct.', 'nov.', 'dec.'];

  // Miezul nopții de azi în Moldova, ca timestamp UTC. Adunarea de zile întregi pe UTC
  // nu e afectată de trecerea la ora de vară/iarnă.
  const aziInMoldova = () => {
    const parti = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Chisinau', year: 'numeric', month: 'numeric', day: 'numeric',
    }).formatToParts(new Date());
    const v = (tip) => Number(parti.find((p) => p.type === tip).value);
    return Date.UTC(v('year'), v('month') - 1, v('day'));
  };

  const scurt = (d) => `${d.getUTCDate()} ${LUNI_SCURT[d.getUTCMonth()]}`;

  const interval = (a, b, lung) => {
    const aceeasiLuna = a.getUTCMonth() === b.getUTCMonth();
    if (lung) {
      return aceeasiLuna
        ? `între ${a.getUTCDate()} și ${b.getUTCDate()} ${LUNI[b.getUTCMonth()]}`
        : `între ${a.getUTCDate()} ${LUNI[a.getUTCMonth()]} și ${b.getUTCDate()} ${LUNI[b.getUTCMonth()]}`;
    }
    return aceeasiLuna
      ? `${a.getUTCDate()}–${b.getUTCDate()} ${LUNI_SCURT[b.getUTCMonth()]}`
      : `${scurt(a)} – ${scurt(b)}`;
  };

  class PfLivrare extends HTMLElement {
    connectedCallback() {
      this.indisponibil = false;
      this.laRevenire = () => {
        if (document.visibilityState === 'visible') this.deseneaza();
      };
      this.laVarianta = (ev) => {
        const d = ev.detail || {};
        if (d.data && d.data.productId && String(d.data.productId) !== this.dataset.productId) return;
        this.indisponibil = !!(d.resource && d.resource.available === false);
        this.hidden = this.indisponibil;
      };
      document.addEventListener('visibilitychange', this.laRevenire);
      document.addEventListener('variant:update', this.laVarianta);
      this.deseneaza();
    }

    disconnectedCallback() {
      document.removeEventListener('visibilitychange', this.laRevenire);
      document.removeEventListener('variant:update', this.laVarianta);
    }

    zile(cheie, implicit) {
      const n = parseInt(this.dataset[cheie], 10);
      return Number.isFinite(n) && n >= 0 && n < 60 ? n : implicit;
    }

    deseneaza() {
      let azi;
      try {
        azi = aziInMoldova();
      } catch (e) {
        return; // browser foarte vechi: blocul rămâne ascuns, nu arătăm date greșite
      }
      const nTrimis = this.zile('trimitere', 1);
      const nMin = this.zile('min', 3);
      const nMax = Math.max(this.zile('max', 5), nMin);
      const trimis = new Date(azi + nTrimis * ZI);
      const primMin = new Date(azi + nMin * ZI);
      const primMax = new Date(azi + nMax * ZI);

      const scrie = (cheie, text) => {
        const el = this.querySelector(`[data-pf-l="${cheie}"]`);
        if (el) el.textContent = text;
      };
      scrie('interval', interval(primMin, primMax, true));
      scrie('trimis', `până pe ${scurt(trimis)}`);
      scrie('primesti', interval(primMin, primMax, false));

      if (!this.indisponibil) this.hidden = false;
    }
  }

  customElements.define('pf-livrare', PfLivrare);
})();
